import { render, staticRenderFns } from "./CustomInputPhone.vue?vue&type=template&id=f8e9ccec&"
import script from "./CustomInputPhone.vue?vue&type=script&lang=ts&"
export * from "./CustomInputPhone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports